import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'work-arrow',
  templateUrl: './work-arrow.component.html',
  styleUrls: ['./work-arrow.component.sass']
})
export class WorkArrowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
